import script from "./HeroFbochasComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroFbochasComponent.vue?vue&type=script&setup=true&lang=js"

import "./HeroFbochasComponent.vue?vue&type=style&index=0&id=a803624a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a803624a"]])

export default __exports__